import React, { FunctionComponent } from 'react'
import { GetStartedWithFacilityApplication } from '@afterpaytouch/registration'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from '../../utils/convergence'
import { useAppRouter, useConsumerFacilityCohort, useCreditFacilityRedirect } from '../../state'
import { Route, usePostGetStartedRoute } from '../../config/router'
import { TrackPageViewed, useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model'

export const GetStartedWrapper: FunctionComponent = () => {
  const { headingSize, textSize } = useCheckoutSizes()
  const router = useAppRouter()
  const { t } = useTranslation()
  const postGetStartedRoute: Route | undefined = usePostGetStartedRoute()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const consumerFacilityCohort = useConsumerFacilityCohort()
  const userContext = consumerFacilityCohort?.getStartedContext ?? 'NEW_USER'
  const redirectToCreditFacility = useCreditFacilityRedirect()

  const onClick = (): void => {
    logEvent(TrackingEvent.PRESSED_GET_STARTED_CONTINUE_BUTTON)

    if (postGetStartedRoute !== undefined) {
      router.push(postGetStartedRoute)
    } else {
      redirectToCreditFacility()
    }
  }
  return (
    <>
      <GetStartedWithFacilityApplication
        onCtaClick={onClick}
        ctaButtonSize={'Large'}
        t={t}
        headingSize={headingSize}
        textSize={textSize}
        userContext={userContext}
      />
      <TrackPageViewed />
    </>
  )
}
